import { createClient, cacheExchange, fetchExchange } from 'urql';

const GRAPHQL_API_PATH = '/api/v1/gql/query';
/**
 * Helper function to strip the __typename field from GraphQL responses (Apollo adds this field
 * to all queried objects by default). Useful, for example, when you're going to be using
 * objects from the response as form field values.
 */ function stripTypenames(payload) {
    return JSON.parse(JSON.stringify(payload), (key, value)=>key === '__typename' ? undefined : value);
}
function createUrqlClient(fetch) {
    const client = createClient({
        requestPolicy: 'cache-and-network',
        url: GRAPHQL_API_PATH,
        fetch,
        exchanges: [
            cacheExchange,
            fetchExchange
        ],
        // urql v5 defaults to GET requests for queries, but our API and MSW expect POST.
        // This option forces POST requests.
        preferGetMethod: false
    });
    return client;
}

export { GRAPHQL_API_PATH, createUrqlClient, stripTypenames };
//# sourceMappingURL=graphql-client.js.map
